import { useNavigate } from "react-router-dom";
import { getLocal, NFeDto, STORAGENFE_KEY, updateLocal } from "../NFe.Dto";
import { useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import yup from "src/validators/yup.Module";
import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Row,
} from "react-bootstrap";
import { FloatInput, showToast } from "src/componentes";

const NFeCadastroReferenciaView = () => {
  const nf = getLocal<NFeDto>(STORAGENFE_KEY);
  const referencia = nf?.referencia;
  const navigate = useNavigate();

  type FormType = yup.InferType<typeof schema>;
  const schema = yup.object({
    dadosReferencia: yup.array().of(
      yup.object().shape({
        chaveAcesso: yup
          .string()
          .length(44, "A chave de acesso deve ter 44 caracteres")
          .required("Chave de acesso é obrigatória"),
      })
    ),
  });

  const handleVoltar = () => {
    navigate("../finalidade");
  };

  const form = useForm<FormType>({
    resolver: yupResolver(schema),
    defaultValues: {
      dadosReferencia: referencia ?? [],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "dadosReferencia",
  });

  const onSubmit = (data: FormType) => {
    if (
      data.dadosReferencia == undefined ||
      data.dadosReferencia.length === 0
    ) {
      showToast({
        message: "Adicione ao menos um documento de referência.",
        variant: "Danger",
        title: "Atenção",
      });
      return;
    }

    const referencias = data.dadosReferencia ?? [];

    updateLocal<NFeDto>(STORAGENFE_KEY, {
      referencia: referencias,
    });

    navigate("../tributacao");
  };

  return (
    <>
      <Form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="mt-3" style={{ marginBottom: "100px" }}>
          {fields.map((field, index) => {
            return (
              <Row key={field.id} className="mb-3">
                <Col xs={12} className="mb-2 d-flex justify-content-between">
                  <strong>Referência {index + 1}</strong>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => remove(index)}
                  >
                    Remover
                  </Button>
                </Col>
                <Col xs={12}>
                  <FloatInput
                    label="Chave de Acesso"
                    maxLength={44}
                    registerField={form.register(
                      `dadosReferencia.${index}.chaveAcesso`
                    )}
                    errorsMessage={
                      form.formState.errors.dadosReferencia?.[index]
                        ?.chaveAcesso
                    }
                  />
                </Col>
              </Row>
            );
          })}
          <div className="d-grid mt-3">
            <Button
              variant="outline-primary"
              onClick={() =>
                append({
                  chaveAcesso: "",
                })
              }
            >
              + Adicionar
            </Button>
          </div>
        </div>

        <div className="fixed-bottom">
          <Container className="py-3">
            <Row>
              <Col xs={6} className="d-grid">
                <Button variant="outline-secondary" onClick={handleVoltar}>
                  Voltar
                </Button>
              </Col>
              <Col xs={6} className="d-grid">
                <Button variant="outline-primary" type="submit">
                  Próximo
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </Form>
    </>
  );
};
export default NFeCadastroReferenciaView;
